
<app-header></app-header>
<main class="pages blog-main">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1>Page Not Found</h1>
                    <p>Sorry, but the page you were trying to view does not exist.</p>
                    <div class="mt-lg-5 mt-3">
                        <a class="btn btn-success btn-lg px-5 text-uppercase" href="" >BACK TO HOME</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img p-3">
                        <img class="img-fluid w-100" alt="Online and Offline Survey" src="assets/404.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>

    <app-footer></app-footer>